import { useQuery } from "@tanstack/react-query";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";
import { getReadingProfile } from "@/lib/reading";

export default function RecommendedForYou({
  seedCategory,
  excludeSlugs = [],
  className = "",
  requireHistory = false,
}) {
  const profile = getReadingProfile();
  const categories = [
    ...new Set([seedCategory, ...profile.categories].filter(Boolean)),
  ].slice(0, 3);
  const exclude = [...new Set([...excludeSlugs, ...profile.slugs])];
  const enabled = !requireHistory || profile.hasHistory;

  const params = new URLSearchParams();
  if (categories.length) params.set("categories", categories.join(","));
  if (exclude.length) params.set("exclude", exclude.join(","));
  params.set("limit", "6");

  const { data } = useQuery({
    queryKey: ["recommended", categories.join(","), exclude.join(","), enabled],
    queryFn: () =>
      api.get(`/articles/recommended?${params.toString()}`).then((r) => r.data),
    enabled,
    staleTime: 60_000,
  });

  const items = data || [];
  if (!enabled || items.length === 0) return null;

  return (
    <section className={className} data-testid="recommended-for-you">
      <div className="mb-5 flex items-center gap-2.5 border-b border-slate-200 pb-3">
        <Sparkles className="h-5 w-5 text-primary" />
        <h2 className="font-display text-2xl font-extrabold text-slate-900">
          Препоръчани за теб
        </h2>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.slice(0, 6).map((a) => (
          <ArticleCard key={a.id} article={a} variant="default" />
        ))}
      </div>
    </section>
  );
}
